import SimpleLightbox from "simplelightbox";
const {burgerMenu} = require("./scripts/burger-menu");
const {runSimpleLightbox} = require("./scripts/simple-lightbox");
const {prevButtons} = require("./scripts/prev-buttons");


document.addEventListener('DOMContentLoaded', function() {
    burgerMenu();
    runSimpleLightbox();
    prevButtons();
});